import store from './../game/store/index.js';
import config from './../config/config.js'
import moment from 'moment';


const datetime = {
	install(Vue, options) {

		Vue.prototype.$datetime = {
			day: function(time, day) {
				if (!time) time = store.state.time;
				if (!day) day = store.state.day;
				return moment().add(day - 1, 'days').hour(config.start_time.hour).minute(config.start_time.minute).second(time).format("D");
			},
			month: function(time, format, day) {
				if (!time) time = store.state.time;
				if (!format) format = "M";
				if (!day) day = store.state.day;
				return moment().add(day - 1, 'days').hour(config.start_time.hour).minute(config.start_time.minute).second(time).format(format);
			},
			year: function (time, day) {
				if (!time) time = store.state.time;
				if (!day) day = store.state.day;
				return moment().add(day - 1, 'days').hour(config.start_time.hour).minute(config.start_time.minute).second(time).format("YY");
			},
			time: function(time, day) {
				if (!time) time = store.state.time;
				if (!day) day = store.state.day;
				return moment().add(day - 1, 'days').hour(config.start_time.hour).minute(config.start_time.minute).second(time).format("h:mm:ssa");
			},
			clock: function(time, day) {
				if (!time) time = store.state.time;
				if (!day) day = store.state.day;
				return moment(store.state.start_date).add(day - 1, 'days').hour(config.start_time.hour).minute(config.start_time.minute).second(time).format("M/D/YY h:mm:ssa");
			},
			date: function(time, day) {
				if (!time) time = store.state.time;
				if (!day) day = store.state.day;
				return moment(store.state.start_date).add(day - 1, 'days').hour(config.start_time.hour).minute(config.start_time.minute).second(time).format("M/D/YY");

			},
			datetime: function(time, day) {
				if (!time) time = store.state.time;
				if (!day) day = store.state.day;
				return moment(store.state.start_date).add(day - 1, 'days').hour(config.start_time.hour).minute(config.start_time.minute).second(time).format("M/D/YY H:mm a");

			},
			convertToUTC(clock, format) {
				if (!format) format = 'MM/DD/YY h:mm:ss a';
				return new Date(moment(clock, format).format('LLL'));
			},
			format(datetime, format) {
				if (!format) format = 'MM/DD/YY h:mm:ss a';
				return moment(datetime).format(format);
			}
		}

	}
};

export default datetime;
